import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TiktokIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tiktok"}/>
}
